import isEmpty from 'lodash/isEmpty';
import isUndefined from 'lodash/isUndefined';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { Modal, Spin, Tooltip } from 'antd';
import { get } from 'lodash';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import { FormattedMessage, WrappedComponentProps, injectIntl } from 'react-intl';

import { WalletPriceType, getWalletPrices } from '@utils';
import { formatDateCheckInOut, GetWalletNumber, renderNumber } from '@share/utils';
import { RootState } from '@share/utils';
import {
  IReviewBookState,
  setCoupon,
  setRedeemCode,
  setUpdateCoupon,
  setSelectedHotelReviewClientCash,
  setSelectedHotelReviewClientCashStr,
  IInsuranceState,
  InsuranceSelection,
} from '@store/slices';
import { IHotelsState, ILoginState, IMenuState, hotelsActions, setLoyaltyNumberFn } from '@share/store/slices';
import { IRedeemCode } from '@common-types';
import { Currency, HotelStars, WalletInput, WalletMessage } from '@components';
import { IAccount, IClientCash, IUserWallet } from '@share/common-types';
import { DATE_FORMAT_CHECK_IN_OUT_YEAR } from '@constants';
import { enUS } from 'date-fns/esm/locale';
import './style.scss';
import { useState } from 'react';
import { BlueButton } from '@share/components';
interface IMapStateToProps {
  reviewBookStore: IReviewBookState;
  hotelsStore: IHotelsState;
  loginStore: ILoginState;
  navigationMenuStore: IMenuState;
  insuranceStore: IInsuranceState;
}

interface IMapDispatchToProps {
  setCoupon: (coupon: string) => void;
  setUpdateCoupon: (coupon: boolean) => void;
  setSelectedHotelReviewClientCash: (selectedClientCash: number) => void;
  setSelectedHotelReviewClientCashStr: (selectedClientCash: string) => void;
  setSelectedHotelSearchClientCash: (selectedClientCash: IClientCash) => void;
  setRedeemCode: (coupon: IRedeemCode) => void;
}

interface IProps
  extends IMapStateToProps,
    IMapDispatchToProps,
    RouteComponentProps,
    WrappedComponentProps {
  balance: any;
  totalFarePrice: any;
  nightsCount: any;
  roomsCount: any;
  savings: any;
  taxes: any;
  formatter: any;
  searchHotels: any;
  showBookCard: any;
}

function BookingDiscountComponent(props: IProps) {
  const { taxes, formatter } = props;
  const { loyaltyNumber } = useSelector((state: RootState) => state.hotelsStore);
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const {
    reviewBookStore,
    navigationMenuStore,
    hotelsStore,
    loginStore,
    insuranceStore,
    intl,
    searchHotels,
    showBookCard,
  } = props;
  const {
    bookingComplete,
    isUpdatePrice,
    bookingSummary,
    selectedHotelReviewClientCash,
    selectedHotelReviewClientCashStr,
    booking,
  } = reviewBookStore;

  const { roomsCount, nightsCount, bookingPrice, balance } = bookingSummary.bookingCard;
  const {
    payAtPropertyFees,
    optionalFees,
    totalFarePrice,
    savings,
    maxWalletClientCash,
    payNowPriceWithoutTaxes,
    payNowPrice,
    totalTaxes,
  } = bookingPrice;

  const { items } = navigationMenuStore;
  const { selection, insurance } = insuranceStore;
  const { account, userWallet, userWalletData } = loginStore;

  const currency = bookingSummary.bookingCard.package.currency;

  const isPayAtPropertyFeesSpecified = !isEmpty(payAtPropertyFees);
  const isOptionalFeesSpecified = !isEmpty(optionalFees);
  const isAnyApproxValueSpecified =
    (isPayAtPropertyFeesSpecified &&
      !isUndefined(payAtPropertyFees.find((f) => f.isApproximateValue))) ||
    (isOptionalFeesSpecified && !isUndefined(optionalFees.find((t) => t.isApproximateValue)));

  const hasClientCash = account?.hasClientCash;
  const clientCashPercentage = account?.clientCashPercentage;
  const isLogged = !!userWallet;

  const usedClientCashAmount =
    bookingComplete && booking ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;
  const balancePaid =
    bookingComplete && booking ? get(booking?.hotelSegments, '[0].totalPay', 0) : 0;

  const isMLM = items?.isMLM;
  const balanceInt = balance;
  const payNowPriceWithoutTaxescalculation = payNowPrice
    ? Math.round((payNowPrice - totalTaxes) * 100) / 100
    : balanceInt;
  const payNowPriceWithoutTaxesInt = payNowPriceWithoutTaxes
    ? Math.round(payNowPriceWithoutTaxes * 100) / 100
    : payNowPriceWithoutTaxescalculation;

  const convertionRate = userWalletData?.convertionRate ? userWalletData?.convertionRate : 1;

  const usedClientCashInt = Math.round(usedClientCashAmount / convertionRate);
  const usedClientCash = account?.walletNoDecimals
    ? Math.floor(usedClientCashInt)
    : usedClientCashInt;

  const clientCashCalculated = bookingComplete
    ? usedClientCashAmount
    : selectedHotelReviewClientCash
    ? selectedHotelReviewClientCash
    : 0;
  const clientCash = clientCashCalculated * convertionRate;
  const finalBalanceIntermediate =
    (bookingComplete ? balancePaid : balanceInt) - (bookingComplete ? 0 : clientCash);
  const finalBalanceCalculated = Math.floor(finalBalanceIntermediate * 100) / 100;
  const finalBalance = finalBalanceCalculated > 0 ? finalBalanceCalculated : 0;
  const eligibleClientCash =
    finalBalance > 0
      ? (finalBalance *
          (clientCashPercentage && !isEmpty(clientCashPercentage)
            ? parseInt(clientCashPercentage)
            : 0)) /
        100
      : 0;

  const maxWalletClientCashInt = maxWalletClientCash;
  const maxWalletClientCashValueInt = maxWalletClientCashInt / convertionRate;
  const maxWalletClientCashValue = account?.walletNoDecimals
    ? Math.floor(maxWalletClientCashValueInt)
    : maxWalletClientCashValueInt;

  const walletPrices = getWalletPrices(
    account as IAccount,
    userWalletData as IUserWallet,
    hotelsStore?.selectedHotelSearchClientCash,
    payNowPriceWithoutTaxesInt,
    maxWalletClientCashValue,
    WalletPriceType.Book,
  );

  const maxWalletClientCashService = walletPrices?.maxClientCashAllow
    ? walletPrices?.maxClientCashAllow
    : 0;
  const maxWalletClientCashFinal =
    maxWalletClientCashValue && maxWalletClientCashValue <= maxWalletClientCashService
      ? maxWalletClientCashValue
      : maxWalletClientCashService;
  const maxWalletClientCashCalculated = account?.walletNoDecimals
    ? Math.floor(maxWalletClientCashFinal)
    : maxWalletClientCashFinal;

  const displayWalletSavings =
    (account?.walletWalletSavings &&
      (walletPrices?.priceSavings > 0 || walletPrices?.maxClientCashAmountAllow > 0) &&
      !!walletPrices?.maxClientCashAmountAllow) ||
    isMLM;

  const insuranceBalance =
    selection === InsuranceSelection.YES && !!insurance?.productDetails?.price
      ? insurance?.productDetails?.price
      : 0;
  
  const handleOnSelectClientCash = (clientCash: string) => {
    const { hotelsStore } = props;
    const { selectedHotelSearchClientCash } = hotelsStore;

    props.setSelectedHotelReviewClientCash(Number(clientCash));
    props.setSelectedHotelReviewClientCashStr(clientCash);
    props.setSelectedHotelSearchClientCash({
      ...selectedHotelSearchClientCash,
      selectedPropertyReviewClientCash: Number(clientCash),
    });
  };
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [loyaltyInput, setLoyaltyInput] = useState<string>(loyaltyNumber);

  const handleSave = () => {
    setLoading(true);
    dispatch(setLoyaltyNumberFn(loyaltyInput));
    setTimeout(() => {
      setIsOpen(false);
      setLoading(false);
    }, 1500);
  }
  const locale = enUS;
  const buttonColor = account?.buttonColor;

  const isBookingComplete = !!bookingComplete;
  const bookingClientCash = isBookingComplete && booking ? get(booking?.hotelSegments, '[0].clientCash', 0) : 0;
  const isExternalWallet = account?.walletIsExternal;

  const isNonRefundable = isBookingComplete && !isExternalWallet && hasClientCash && isLogged && (bookingClientCash > 0 || usedClientCash > 0);
  const refundability = isNonRefundable ? 'nonrefundable' : searchHotels?.bookingCard?.package?.refundability;

  const clientCashName = isEmpty(account?.walletClientCashName) ? 'Client Cash' : account?.walletClientCashName;
  const clientCashAmountApplied = clientCash / convertionRate;
  
  return (
    <>
      <div className="sticky-top z-1 mb-xl-0 mb-5">
        {showBookCard && (
          <div className="hotelCard card shadow rounded-0 border-0">
            <div className="position-relative">
              <img
                src={searchHotels?.bookingCard?.titleImage}
                alt="Hotel"
                className="img-fluid w-100 h-100 object-fit-cover"
              />
              <div className="position-absolute top-0 start-0 text-white px-2 py-2 w-100 hotelCard_badge">
                <FormattedMessage id="popular.room" />
              </div>
              <div className="position-absolute text-white text-end px-4 pt-3 pb-2 hotelCard_rateBadge">
                <div>
                  <FormattedMessage id="avg.rate" />
                </div>
                <strong>{formatter.format(searchHotels?.bookingCard?.package?.pricePerNight.toFixed(2) || '0')}</strong>
                <div className="night">
                  <FormattedMessage id="per.night" />
                </div>
              </div>
              <div className="position-absolute top-25 start-0 text-white px-3 py-1 hotelCard_save">
                {`${intl.formatMessage({ id: 'save' })} ${searchHotels?.bookingCard?.package?.savingPercent.toFixed(2)}`}%
              </div>
            </div>

            <div className="p-3 hotelCard_cnt">
              <h5 className="mb-1 hotelCard_cnt_title">{searchHotels?.bookingCard?.name}</h5>
              <h4 className="mb-1">
                <HotelStars stars={searchHotels?.bookingCard?.stars} />
              </h4>
              <p className="mb-2 hotelCard_cnt_address">
                {[
                  searchHotels?.bookingCard?.address,
                  searchHotels?.bookingCard?.city,
                  searchHotels?.bookingCard?.state,
                  searchHotels?.bookingCard?.zipCode,
                  searchHotels?.bookingCard?.countryName,
                ]
                  .filter(Boolean)
                  .join(', ')}
              </p>

              <div className="text-dark mb-1 hotelCard_cnt_booking">
                <strong>{searchHotels?.bookingCard?.roomDescription}</strong>
              </div>
              <div className="mb-2 hotelCard_cnt_room"><FormattedMessage id="hotel.details.room.only" /></div>
              {refundability === 'nonrefundable' && (
                <ul className="list-group list-group-borderless small mb-0 mt-2">
                  <li className="list-group-item d-flex text-danger p-0">
                    <FormattedMessage id="hotel.non.refundable" /> <i className="bi bi-info-circle-fill ms-2"></i>
                  </li>
                </ul>
              )}
              {refundability === 'refundable' && (
                <ul className="list-group list-group-borderless small mb-3 mt-0">
                  <li className="list-group-item d-flex text-success p-0">
                    <FormattedMessage id="hotel.refundable" /> <i className="bi bi-info-circle-fill ms-2"></i>
                  </li>
                </ul>
              )}
              <div style={{ fontSize: '0.85rem' }}>
                <div className="mb-1">
                  <b className="text-dark me-1"><FormattedMessage id="check.in" />:</b>
                  {formatDateCheckInOut(
                    searchHotels?.bookingCard?.checkIn,
                    DATE_FORMAT_CHECK_IN_OUT_YEAR,
                    locale,
                  )}
                </div>
                <div>
                  <b className="text-dark me-1"><FormattedMessage id="check.out" />:</b>
                  {formatDateCheckInOut(
                    searchHotels?.bookingCard?.checkOut,
                    DATE_FORMAT_CHECK_IN_OUT_YEAR,
                    locale,
                  )}
                </div>
              </div>
              <div className="mt-1 text-dark" style={{ fontSize: '0.85rem' }}>
                <FormattedMessage id="nights.stay" values={{ count: searchHotels?.bookingCard?.nightsCount }} />
              </div>
            </div>
          </div>
        )}
        {showBookCard && <div className={`card shadow p-3 rounded-0 priceDetailsCard ${showBookCard ? 'mt-3' : ''}`}>
          <div className="card-header border-0 p-0">
            <h5 className="card-title mb-0 priceDetailsCard_title pt-3"><FormattedMessage id="price.details" /></h5>
            <p className="priceDetailsCard_para"><FormattedMessage id="avg.nightly.rate" />: {formatter.format(searchHotels?.bookingCard?.package?.pricePerNight || '0')}  <FormattedMessage id="per.night" /></p>
          </div>
          <div className="card-body py-3 px-0">
            <ul className="priceDetailsCard_list mb-0 list-unstyled">
              <li className="d-flex align-items-center justify-content-between gap-3">
                <span className="text-dark">
                  <FormattedMessage id="public.price" />: {roomsCount} <FormattedMessage id="payments.room" values={{ count: roomsCount }} />,
                  <FormattedMessage id="nights" values={{ count: nightsCount }} />
                </span>
                <span className="text-dark">{formatter.format(totalFarePrice)}</span>
              </li>
              <li className="d-flex align-items-center justify-content-between gap-3">
                <span><FormattedMessage id="savings" /></span>
                <span>{formatter.format(Number(savings) || 0)}
                </span>
              </li>
              <li className="d-flex align-items-center justify-content-between gap-3">
                <span className="text-dark">
                  <FormattedMessage id="taxes" /> <i className="bi bi-info-circle-fill"></i>
                </span>
                <span className="text-dark">{formatter.format(taxes || '0')}</span>
              </li>
              {bookingComplete && clientCash > 0 && (
                <li className="d-flex align-items-center justify-content-between gap-3">
                  <span className="text-dark">
                    <p className="hotel-card-wrapper__commission-text bigger text-info">
                      <FormattedMessage id="wallet.client.cash.applied" values={{ clientCash: GetWalletNumber(clientCash, account), clientCashName }} />
                    </p>
                  </span>
                  <span className="text-dark">
                    <p className="hotel-card-wrapper__commission-text text-info">
                      <Currency currency={currency} />{renderNumber(clientCashAmountApplied, 2)}
                    </p>
                  </span>
                </li>)}



                {/*<div className="hotel-card-wrapper__price-public" style={textStyles}>
                  {(isOneLine && !account?.walletHideAmount) ? (
                    <p className={`hotel-card-wrapper__commission-text text-info ${greenText ? 'green' : ''}`}>
                      <Currency currency={currency} />{renderNumber(clientCashAmountApplied, 2)}
                    </p>) : null}
                  {(isOneLine && account?.walletHideAmount && type !== WalletPriceType.Search) ? (
                    <p className={`hotel-card-wrapper__commission-text text-info ${greenText ? 'green' : ''}`}>
                      {GetWalletNumber(clientCashApplied, account)}
                    </p>) : null}
                </div>*/}

              {insuranceBalance > 0 && <li className="d-flex align-items-center justify-content-between gap-3">
                <span className="text-dark"><FormattedMessage id="Travel Insurance" /></span>
                <span className="text-dark">{formatter.format(insuranceBalance)}</span>
              </li>}
            </ul>
            <div className="card-footer pt-3 mt-3 pb-0 px-0 priceDetailsCard_footer">
              <div className="d-flex align-items-center justify-content-between gap-3 mb-3">
                <span className="text-dark"><FormattedMessage id="total.paid" />:</span>
                <span className="f-20 text-dark">
                {formatter.format(renderNumber(Number(finalBalance || 0) + Number(insuranceBalance || 0), 2))}
                </span>
              </div>
              <p className="note mb-0"><FormattedMessage id="including.taxes" /> {formatter.format(taxes || '0')}</p>
            </div>
          </div>
        </div>}
        {/* Final Payment Details  page start*/}
        {!showBookCard && (
            <div className="card shadow rounded-2">
              <div className="card-header p-4 border-bottom">
                <h4 className="card-title mb-0"><FormattedMessage id="final.payment.details" /></h4>
              </div>
              <div className="card-body p-4">
                <ul className="list-group list-group-borderless">
                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="h6 fw-light mb-0">
                      {roomsCount} <FormattedMessage id="payments.room" values={{ count: roomsCount }} />,
                      <FormattedMessage id="nights" values={{ count: nightsCount }} />
                    </span>
                    <span className="fs-5">{formatter.format(totalFarePrice)}</span>
                  </li>

                  <li className="mt-1 list-group-item d-flex justify-content-between align-items-center">
                    <span className="h6 fw-light mb-0"><FormattedMessage id="taxes.fees"/> </span>
                    <span className="fs-5">{formatter.format(taxes || '0')}</span>
                  </li>

                  {hasClientCash && !account?.walletIsExternal && !items?.isMLM ? (
                    <li className="mt-1 list-group-item d-flex justify-content-between align-items-center">
                      <span className="h6 fw-light mb-0 text-info">
                        <FormattedMessage
                          id="wallet.client.cash.eligible"
                          values={{
                            value: clientCashPercentage,
                            clientCashName: account?.walletClientCashName,
                          }}
                        />
                        <Tooltip
                          title={intl.formatMessage({ id: 'wallet.client.cash.eligible.tooltip' })}
                          placement="topLeft"
                        >
                          <FontAwesomeIcon
                            icon={faInfoCircle}
                            size="1x"
                            style={{ marginLeft: '5px' }}
                          />
                        </Tooltip>
                      </span>
                      <span className="fs-5 text-info">
                        <Currency currency={currency} />
                        {renderNumber(eligibleClientCash, 2)}
                      </span>
                    </li>
                  ) : null}

                  <hr className="m-0" />

                  <li className="list-group-item d-flex justify-content-between align-items-center">
                    <span className="h6 fw-light mb-0"><FormattedMessage id="savings" /></span>
                    <span className="fs-5 text-success">-$ {savings?.toLocaleString()}</span>
                  </li>
                </ul>

                <hr className="m-0" />

                <WalletInput
                  display={
                    (hasClientCash && isLogged && !bookingComplete) ||
                    ((isMLM && !bookingComplete) as boolean)
                  }
                  bottomBorder
                  currency={currency}
                  maxWalletClientCash={maxWalletClientCashCalculated}
                  price={payNowPriceWithoutTaxesInt}
                  selectedClientCash={selectedHotelReviewClientCash}
                  selectedClientCashStr={selectedHotelReviewClientCashStr}
                  onSelectClientCash={handleOnSelectClientCash}
                />

                {!displayWalletSavings ? (
                  <WalletMessage
                    price={balanceInt}
                    maxClientCash={maxWalletClientCashCalculated}
                    currency={currency}
                    type={WalletPriceType.Book}
                    displayOnlyRate={bookingComplete}
                    isOneLine
                    style={{ marginBottom: '15px' }}
                  />
                ) : null}

                {account?.walletDisplayGetMoreClientCash &&
                walletPrices?.maxClientCashAllow > (walletPrices?.maxClientCashPermited || 0) ? (
                  <div className="room-info__content text-danger" style={{ paddingBottom: '0px' }}>
                    <FormattedMessage
                      id="wallet.client.get_more"
                      values={{
                        diff:
                          Math.floor((walletPrices?.maxClientCashAllow -
                          (walletPrices?.maxClientCashPermited || 0)) * 100) / 100,
                        clientCashName: account?.walletClientCashName,
                      }}
                    />
                  </div>
                ) : null}

                {hasClientCash && bookingComplete ? (
                  <div
                    className="room-info__price-info"
                    style={{ paddingTop: '0px', paddingBottom: '10px' }}
                  >
                    <p className="room-info__price-client-cash-text">
                      <FormattedMessage
                        id="wallet.client.cash.applied"
                        values={{
                          clientCash: usedClientCash,
                          clientCashName: account?.walletClientCashName,
                        }}
                      />
                    </p>
                    <p className="room-info__price-client-cash-text">
                      <Currency currency={currency} />
                      {renderNumber(usedClientCashAmount, 2)}
                    </p>
                  </div>
                ) : null}
              </div>

              {!isUpdatePrice && (
                <div className="card-footer border-top p-4">
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="h5 mb-0"><FormattedMessage id="payable.now" /></span>
                    <span className="h5 mb-0 fw-bold">
                      <Currency currency={currency} />
                      {renderNumber(finalBalance + insuranceBalance, 2)}
                    </span>

                    {isAnyApproxValueSpecified && (
                      <div className="room-info__fee-wrapper">
                        <div className="room-info__note">
                          <FormattedMessage id="fee.instruction" />
                        </div>
                      </div>
                    )}
                  </div>
                  {/* {!loyaltyNumber ? <span className='d-inline-flex mt-2'>Enter your <span className='fw-bold text-primary ps-1 linkHover' style={{ cursor: 'pointer', }} onClick={() => setIsOpen(true)}>Loyalty Number</span></span> : null} */}
                </div>
              )}
            </div>
          )}
        {/* <div className="col-md-6 col-xl-12">
        <div className="card shadow">
          <div className="card-header border-bottom">
            <div className="cardt-title">
              <h5 className="mb-0">Discount Code</h5>
            </div>
          </div>
          <div className="card-body">
            <div className="input-group">
              <input className="form-control" placeholder="Enter code" />
              <button type="button" className="btn btn-primary">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div> */}
      </div>
      <Modal
        visible={isOpen}
        title={`${loyaltyNumber ? 'Edit your' : 'Enter your'} Loyalty Number`}
        onCancel={() => setIsOpen(false)}
        footer={[
          <div className="p-2 d-flex justify-content-end align-items-center">
            <BlueButton 
              block
              size="large"
              type="primary"
              key="cancel"
              className={`btn mb-0 mh-40 ${buttonColor ? '' : 'commonBlueBtn_Outline'}`}
              onClick={() => setIsOpen(false)}
            >
              <FormattedMessage id="cancel.button" />
            </BlueButton>
            <BlueButton
              block
              size="large"
              type="primary"
              key="submit"
              htmlType="submit"
              className="btn btn-primary mh-40"
              onClick={handleSave}
              loading={loading}
            >
              {loading ? <Spin spinning={true} style={{minWidth: '112px'}}/> : <FormattedMessage id="save.changes" />}
            </BlueButton>
          </div>,
        ]}
      >
        <input
          type="text"
          className="form-control border-top-0 border-start-0 border-end-0 rounded-0 border-primary"
          value={loyaltyInput}
          placeholder="Loyalty Number"
          onChange={(e) => setLoyaltyInput(e.target.value)}
        />
    </Modal>
    </>
  );
}

const mapStateToProps = (state: RootState): IMapStateToProps => {
  return {
    reviewBookStore: state.reviewBookStore,
    hotelsStore: state.hotelsStore,
    navigationMenuStore: state.navigationMenuStore,
    loginStore: state.loginStore,
    insuranceStore: state.insuranceStore,
  };
};

const mapDispatchToProps: IMapDispatchToProps = {
  setCoupon,
  setRedeemCode,
  setUpdateCoupon,
  setSelectedHotelReviewClientCash,
  setSelectedHotelReviewClientCashStr,
  setSelectedHotelSearchClientCash: hotelsActions.setSelectedHotelSearchClientCash,
};

const BookingDiscount = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(injectIntl(BookingDiscountComponent)));
export default BookingDiscount;
